export class MailAnalysisState {
    public currentMonthEmailCount: number | null = null;

    public monthlyAnalysedMailsLimit: number | null = null;
}
